export default __webpack_public_path__ + "static/media/icon_download.71040d67.svg";